import type { TextKey } from "../i18n/en.ts";

export interface SampleProject {
  key: string;
  url: string;
  fileName: string;
  /** `null` means this sample's real-world CRS is NOT confirmed — never guess one; opens in plane mode only instead. */
  epsgCode: string | null;
  nameKey: TextKey;
  attributionKey: TextKey | null;
  sourceUrl: string | null;
  /** SPDX short identifier of the license the full attribution declares
   *  (e.g. `GPL-3.0`). Rendered as the visible tag in the example banner's
   *  compact chip; `null` when the sample carries no third-party attribution
   *  at all (public-domain or first-party — Victoria today). */
  license: string | null;
}

export const SAMPLE_PROJECTS: SampleProject[] = [
  {
    key: "victoria",
    url: "/samples/Victoria.inp",
    fileName: "Victoria.inp",
    epsgCode: "32610",
    nameKey: "landing.sampleVictoriaName",
    attributionKey: null,
    sourceUrl: null,
    license: null,
  },
  {
    key: "hague",
    url: "/samples/Hague.inp",
    fileName: "Hague.inp",
    epsgCode: null,
    nameKey: "landing.sampleHagueName",
    attributionKey: "sampleAttribution.hague",
    sourceUrl: "https://github.com/Zhiyu014/GNN-UDS",
    license: "GPL-3.0",
  },
  {
    key: "chaohu",
    url: "/samples/Chaohu.inp",
    fileName: "Chaohu.inp",
    epsgCode: null,
    nameKey: "landing.sampleChaohuName",
    attributionKey: "sampleAttribution.chaohu",
    sourceUrl: "https://github.com/Zhiyu014/GNN-UDS",
    license: "GPL-3.0",
  },
  {
    key: "bogota",
    url: "/samples/Bogota.inp",
    fileName: "Bogota.inp",
    epsgCode: null,
    nameKey: "landing.sampleBogotaName",
    attributionKey: "sampleAttribution.bogota",
    sourceUrl: "https://github.com/gandresr/MatSWMM",
    license: "GPL-3.0",
  },
];
